/**
 * Undo everywhere (spec §9.24): a Loro UndoManager per open doc on this device. Only this peer's
 * ops are undone; remote edits are never reverted. Ctrl+Z / Ctrl+Shift+Z are bound in the shell.
 */
import { UndoManager, type LoroDoc } from "loro-crdt";

const managers = new WeakMap<LoroDoc, UndoManager>();

export function undoManagerFor(doc: LoroDoc): UndoManager {
  let m = managers.get(doc);
  if (!m) {
    m = new UndoManager(doc, { maxUndoSteps: 200, mergeInterval: 0 });
    managers.set(doc, m);
  }
  return m;
}

export function undo(doc: LoroDoc): boolean {
  const m = undoManagerFor(doc);
  if (!m.canUndo()) return false;
  m.undo();
  return true;
}

export function redo(doc: LoroDoc): boolean {
  const m = undoManagerFor(doc);
  if (!m.canRedo()) return false;
  m.redo();
  return true;
}
